import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourConsentsApi from '@/features/dashboard/tourConsents/api/tourConsentsApi.ts';
import { toast } from 'sonner';
import { tourConsentsApiQueryKeys } from '@/features/dashboard/tourConsents/api/tourConsentsApi.queryKeys.ts';

export default function useRemoveTourConsent(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tourConsentsApi.remove,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourConsentsApiQueryKeys.byTourId(tourId),
      });
      toast.success('Zgoda została usunięta');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Wystąpił błąd podczas usuwania zgody.',
      });
    },
  });
}
